module.exports = __webpack_public_path__ + "assets/634f62e656de2b011e14476b7a03a1ae.png";